export enum PaymentModalContents {
    SUMMARY = "summary",
    PAYMENT = "payment",
    SUCCESS = "success",
    FAILURE = "failure",
}


    // "summary" | "payment" | "success" | "failure";